import C7Card from "./c7-card";
import C7Collection from "./c7-collection";
import C7ProductDetails from "./c7-product-details";
import PopUp from "./popup";

var varietal_ids=[];
var vintage_ids=[];
var filtering_price = [];
var min = 0;
var max = 200;
jQuery(document).ready(function($) {

	new C7Collection().init();
	new C7ProductDetails().init();
	new C7Card().init();
    new PopUp().init();

    /* Sticky add to cart button */
    $(document).on('scroll', function() {
        if ($('.c7-product-detail__content .c7-product__variant__add-to-cart').length) {
            if ( $(this).scrollTop() >= $('.c7-product-detail__content .c7-product__variant__add-to-cart').position().top ) {
                $( '.c7-product-sticky' ).show()
            }
            else{
                $( '.c7-product-sticky' ).hide()
            }
        }
    });

	/* Smooth anchor scroll */
	$(document).on("click", 'a[href^="#"]', function (e) {
        e.preventDefault();
        const href = $(this).attr('href')
        if (href.length > 1 && $(href) && !$(this).hasClass('view-cart')) {
            $("html, body").animate(
                {
                    scrollTop: $(href).offset().top,
                },
                500
            );
        }
	});

	/* Wine Profile Accordion */
	$(document).on("click", ".c7-product-profile__label", function () {
		$(this)
			.closest(".c7-product-profile")
			.find(".c7-product-profile__label.opened")
			.each((_, label) => {
				if (label === this) return;
				$(label).removeClass("opened").next().slideUp(500);
			});

		if ($(this).hasClass("opened")) {
			$(this).removeClass("opened").next().slideUp(500);
		} else {
			$(this).addClass("opened").next().slideDown(500);
		}
    });

    /* Experience Reserve Button Click */
    $(document).on('click', ".c7-experience__reserve", function() {
        $(this).closest('.experience').find('.c7-reservation-availability').slideDown(500);
        $([document.documentElement, document.body]).animate({
            scrollTop: $('.c7-reservation-availability').offset().top - window.innerHeight / 2
        }, 1000);
        $(this).remove();
    })

    /* Trade & Media */
    $(document).on("click", '.blk__wine_assets .wine-name', function() {
        $(this).closest('.wine').toggleClass('expanded');
    })

    $(document).on("click", ".blk__wine_assets .download-all", function() {
        const link = document.createElement('a');
        link.style.display = 'none';
        link.target = '_blank';
        link.download = '';
        document.body.appendChild(link)

        $(this).closest('.wine').find('.wine-assets a').each((index, el) => {
            if (el.href) {
                link.href = el.href;
                link.click();
                window.URL.revokeObjectURL(el.href)
            }
        });
    })


    /*******************************************
     * TODO: cleanup
     *******************************************/

    /************************
     * compare clubs - start
     ************************/
    $(".club-names .club-name").on("click", function() {
        $(".club-names .club-name").removeClass("active")
        $(this).addClass("active")
        $(".comparing-categories .compare-value.active").removeClass("active")
        $(".comparing-categories .value-" +  $(this).data('wine_id')).addClass("active")
    })
     /***********************
     * compare clubs - end
     ************************/

    /***************************
     * background video - start
     ***************************/
    $(".video-player").on("click", function(){
        if ($(this).hasClass("icon-pause")) {
            $(this).removeClass("icon-pause")
            $(this).addClass("icon-play")
            if ($(this).hasClass("youtube-video")) {
                $(this).siblings(".video-container").children(".background-video").each(function() {
                    this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
                });
            } else if ($(this).hasClass("vimeo-video")) {
                $(this).siblings(".video-container").children(".background-video").each(function() {
                    this.contentWindow.postMessage('{"method":"pause"}', '*')
                });
            }
        } else {
            $(this).removeClass("icon-play")
            $(this).addClass("icon-pause")
            if ($(this).hasClass("youtube-video")) {
                $(this).siblings(".video-container").children(".background-video").each(function(){
                    this.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
                });
            } else if ($(this).hasClass("vimeo-video")) {
                $(this).siblings(".video-container").children(".background-video").each(function(){
                    this.contentWindow.postMessage('{"method":"play"}', '*')
                });
            }
        }
    })
    /*************************
     * background video - end
     *************************/

    /*******************************
     * purchase event ticket - start 
     *******************************/
    $(".shop-add-to-cart .button").on("click", function() {
        $(this).closest('.event-atc').find('.v65-widgetProduct-addToCart form:first-child .add-to-cart').click();
        $('.product-modal-img').css({"background": "url(" + $(this).data("image") + ") no-repeat center","background-size": "cover", "height": "300px", "margin": "40px", "box-sizing": "border-box"});
        $('.overlay').addClass('modal-show');
    });
    $('.quantity').on("keyup", function() {
        var $this = $(this);
        $this.val($this.val().replace(/[^\d]/g, ''));
        var quantity = $this.val();
        $(this).closest('.event-atc').find('.v65-widgetProduct-addToCart form:first-child .v65-widgetProduct-addToCart-quantity input').val($this.val());
        if($('.is_sticky').length > 0){
            $('.quantity').not(this).each(function(){
                $(this).val(quantity);
            });
        }
    });
    /*******************************
     * purchase event ticket - end
     *******************************/

    var is_desktop = window.innerWidth > 1024;
    window.onresize = function() {
        var current_mode =  window.innerWidth > 1024;
        if (current_mode && !is_desktop) {
            $('.main-menu').css("display","flex");
            $('header').siblings().removeClass('d-none');
            $('header').parents().siblings().removeClass('d-none');
            $('body').css('overflow-x', 'hidden');
            $('html').css('overflow-x', 'hidden');
            is_desktop = !is_desktop;
        }
        else if (!current_mode && is_desktop) {
            $('.main-menu').css("display","none");
            $('#menu-btn').attr('checked',false);
            is_desktop = !is_desktop;
        }
    }
    jQuery("#category-post-content-ajax").hide();
    // $(".photo-gallery.owl-carousel").owlCarousel({
    //     smartSpeed: 650,
    //     nav: false,
    //     autoplay: true,
    //     dots: true,
    //     items: 1,
    //     loop: true,
    //     lazyLoad: true
    // });

    $(".product-modal").hide();
    min = parseInt($('#rangeSlider').data('min'));
    max = parseInt($('#rangeSlider').data('max'));
    if($('.is_category_page').length > 0){
        ajax_filter_category();
    }
    var rating = parseInt($('.rating-score span').html());
    $('.rating-score span').html(rating.toLocaleString());
    $('.rating-counts span').each(function(){
        var rating_wine = parseInt($(this).html());
        $(this).html(rating_wine.toLocaleString());
    });
    $(".individual-filter").hover(function(){
        if(!is_desktop) return false;
        $(this).find('.filter-dropdown').css('display', 'block');
     }, function() {
        if(!is_desktop) return false;
        $(this).find('.filter-dropdown').css('display', 'none');
    });
    $(".wine-filter").click(function(e) {
        if(!is_desktop){
            $(this).parent().find('.mobile-filter-popup').addClass('modal-show');
            $('html').addClass('lock-scroll');
        }
      });
    $(document).on('click','.mobile-filter-popup .icon-close', function(){
        $('.mobile-filter-popup').removeClass('modal-show');
        $('html').removeClass('lock-scroll');
        ajax_filter_category();
    });
    $('.fitler-checkbox input').click(function(){
        var filter_type = $(this).closest('.mobile-filter-popup').find('.mobile-filter-title').text().toLowerCase();
        var currentID = $(this).data('id');
        var currentKey = $(this).data('key');
        if($(this).is(":checked")) {    
            if(currentKey == null){
                var str;
                var filteringClass = '.fitler-checkbox.' + filter_type;
                str = '<span class="filtering-category filtering-'+filter_type+'" data-id="'+ currentID + '">' + currentID + '<span class="icon-close"></span></span>';
                $('.filtering-category-contatiner').append(str);
                $('.filtering-category .icon-close').on('click',function(){
                    var closeID = $(this).parent().data('id');
                    $(this).parent().remove();
                    $(filteringClass).each(function() {
                         if($(this).find('input').data('id') == closeID){
                            $(this).find('input').prop('checked', false);
                         }
                    });
                    ajax_filter_category();
                });
            }
            else{
                var str;
                var filteringClass = '.fitler-checkbox.' + filter_type;
                str = '<span class="filtering-category  filtering-varietal" data-id="'+ currentID +'" data-key="'+ currentKey +'">' + currentID  + '<span class="icon-close"></span></span>';
                $('.filtering-category-contatiner').append(str);
                $('.filtering-category .icon-close').on('click',function(){
                    var closeID = $(this).parent().data('id');
                    $(this).parent().remove();
                    $(filteringClass).each(function() {
                        if($(this).find('input').data('id') == closeID){
                           $(this).find('input').prop('checked', false);
                        }
                    });
                    ajax_filter_category();
                });
            }
        }
        else {
            $('.filtering-category').each(function(){
                if($(this).data('id') == currentID){
                    $(this).remove();
                }
            });
        }
    });
    $('.filter-show-result').click(function(){
        $('.mobile-filter-popup').removeClass('modal-show');
        $('html').removeClass('lock-scroll');
        ajax_filter_category();
    });
    $("#menu-btn").change(function() {
        if(this.checked) {
            setTimeout(function(){$('header').siblings().addClass('d-none');},500);
            setTimeout(function(){$('header').parents().siblings().addClass('d-none');}, 500);
            $('body').css('overflow-x', 'visible');
            $('html').css('overflow-x', 'visible');
            $('.announcement_bar').removeClass('d-none');
            $('.main-menu').slideDown(500);
        }
        else{
            $('.main-menu').slideUp(500);
            $('header').siblings().removeClass('d-none');
            $('header').parents().siblings().removeClass('d-none');
            $('body').css('overflow-x', 'hidden');
            $('html').css('overflow-x', 'hidden');
        }
    });
     $('.filter-dropdown').click(function(){
         $(this).css('display', 'none');
     });
     $(".vintage-category").click(function(){
        if($(this).hasClass('clicked')){
            return false;
        }
        else{
            var currentID = $(this).data('id');
            var str;
            str = '<span class="filtering-category filtering-vintage" data-id="'+ currentID + '">' + $(this).text()  + '<span class="icon-close"></span></span>';
            $('.filtering-category-contatiner').append(str);
            ajax_filter_category();
            $(this).addClass('clicked');
        }
     });
     $(".varietal-filter").click(function(){
        if($(this).hasClass('clicked')){
            return false;
        }
        else{
            $("#loading-animation").show();
            var currentID = $(this).data('id');
            var currentKey = $(this).data('key');
            var str;
            str = '<span class="filtering-category  filtering-varietal" data-id="'+ currentID +'" data-key="'+ currentKey +'">' + $(this).text()  + '<span class="icon-close"></span></span>';
            $('.filtering-category-contatiner').append(str);
            ajax_filter_category();
            $(this).addClass('clicked');
        }
        
    });
    $(".type-filter").click(function(){
        if($(this).hasClass('clicked')){
            return false;
        }
        else{
            $("#loading-animation").show();
            var currentID = $(this).data('id');
            var str;
            str = '<span class="filtering-category  filtering-type" data-id="'+ currentID +'">' + $(this).text()  + '<span class="icon-close"></span></span>';
            $('.filtering-category-contatiner').append(str);
            ajax_filter_category();
            $(this).addClass('clicked');
        }
    });
    //  $("#rangeSlider").slider({
    //     range: true,
    //     min: min,
    //     max: max,
    //     values: [min, max],
    //     slide: function (event, ui) {
    //         $( "#amount" ).html( "$" + ui.values[ 0 ] + " - $" + ui.values[ 1 ] );
    //     },
    //     stop: function  (event, ui) {
    //         var str2;
    //         str2 = '<span class="filtering-category  filtering-price" data-low="'+ui.values[ 0 ]+'" data-upper="'+ ui.values[ 1 ]+'">$' + ui.values[ 0 ] + '- $' + ui.values[ 1 ] + '<span class="icon-close"></span></span>';
    //         $('.filtering-price').remove();
    //         $('.filtering-category-contatiner').append(str2);
    //         $('.filtering-price .icon-close').on('click',function(){
    //             $(this).parent().remove();
    //             ajax_filter_category();
    //          });
    //         $('.price-filter').hide();
    //         ajax_filter_category();
    //     }
    // });
    // $("#rangeSlider-mobile").slider({
    //     range: true,
    //     min: min,
    //     max: max,
    //     values: [min, max],
    //     slide: function (event, ui) {
    //         $( "#amount-mobile" ).html( "$" + ui.values[ 0 ] + " - $" + ui.values[ 1 ] );
    //     },
    //     stop: function  (event, ui) {
    //         var str2;
    //         str2 = '<span class="filtering-category  filtering-price" data-low="'+ui.values[ 0 ]+'" data-upper="'+ ui.values[ 1 ]+'">$' + ui.values[ 0 ] + '- $' + ui.values[ 1 ] + '<span class="icon-close"></span></span>';
    //         $('.filtering-price').remove();
    //         $('.filtering-category-contatiner').append(str2);
    //         $('.filtering-price .icon-close').on('click',function(){
    //             $(this).parent().remove();
    //             ajax_filter_category();
    //          });
    //         $('.price-filter').hide();
    //         ajax_filter_category();
    //     }
    // });
    $(document).on("keyup", '.quantity' , function (e) {  
        var $this = $(this);
        $this.val($this.val().replace(/[^\d]/g, ''));
        var event = $.Event( "keyup", { which: e.keyCode } );
        console.log(e.keyCode);
        $(this).closest('.product').find('.c7-product__variant .c7-product__variant__add-to-cart input').focus();
        $(this).closest('.product').find('.c7-product__variant .c7-product__variant__add-to-cart input').trigger(event);
        console.log($(this).closest('.product').find('.c7-product__variant .c7-product__variant__add-to-cart input').val());
    });
    $(document).on("keyup", '.per-alternate-quantity' , function () {  
        var $this = $(this);
        $this.val($this.val().replace(/[^\d]/g, ''));
        $(this).closest('.product').find('.v65-widgetProduct-addToCart form:nth-child(3) .v65-widgetProduct-addToCart-quantity input').val($this.val());
    });
    $(document).on("click", ".add-to-cart-btn.per-bottle", function() {
        $(this).closest('.product').find('.v65-widgetProduct-addToCart form:first-child .add-to-cart').click();
        $('.overlay').addClass('modal-show');
        var str = $('.product-image').html();
        $('.product-modal-img').html(str);
    });
    $('.add-to-cart-btn.per-alternate').click(function(){
        $('.v65-widgetProduct-addToCart form:nth-child(3) .add-to-cart').click();
        $('.overlay').addClass('modal-show');
        var str = $('.product-image').html();
        $('.product-modal-img').html(str);
    });
    $(document).on("click", ".shop-add-to-cart p", function() {
        $(this).closest('.product').find('.c7-product__variant .c7-button').click();
    });
    $(document).on("click", ".shop-case-cart", function() {
        $.ajax({
            type: "GET",
            url: "?addToCart=2015C&quantity=5",
            success: function (res){
                console.log(res);
            }
        });
    });
    $(document).on("click", ".icon-cart", function() {
        $('section.c7-cart').addClass('c7-visible')
    });
    $(document).on("click", ".c7-cart__close", function() {
        $('section.c7-cart').removeClass('c7-visible')
    });
    $(document).on("click", ".filtering-category .icon-close", function() {
        var currentID = $(this).parent().data('id');
        $(this).parent().remove();
        $('.type-varietal-category').each(function() {
             if($(this).data('id') == currentID){
                 $(this).removeClass('clicked');
             }
         });
         $('.vintage-category').each(function() {
            if($(this).data('id') == currentID){
                $(this).removeClass('clicked');
            }
        });
        ajax_filter_category();
     });
    $('.clear-filter').click(function(){
        $('.filtering-category').each(function(){
            $('.filter-dropdown li').each(function(){
                if($('.filtering-category').data('id') == $(this).data('id')){
                    $(this).removeClass('clicked');
                }
            });
            $(this).remove();
        });
        $('.fitler-checkbox input').each(function(){
            $(this).prop('checked',false);
        });
        ajax_filter_category();
    });
    $('.add-to-cart-btn.per-case').click(function(){
        $('.v65-widgetAddToCartCase .add-to-cart').click();
        $('.overlay').addClass('modal-show');
        
    });
    $('#prick_check').click(function(){
        $('.add-to-cart-form').css({"display":"flex"});
        $('.per-case').css({"display":"none"});
        $('.add-to-cart-alternate').css({"display":"none"});
    });
    $('#case_check').click(function(){
        $('.add-to-cart-form').css({"display":"none"});
        $('.per-case').css({"display":"flex"});
        $('.add-to-cart-alternate').css({"display":"none"});
    });
    $('#alternate_check').click(function(){
        $('.add-to-cart-form').css({"display":"none"});
        $('.per-case').css({"display":"none"});
        $('.add-to-cart-alternate').css({"display":"flex"});
    });
    $('.product-modal .icon-close').click(function(){
        $('.overlay').removeClass('modal-show');
        $('.product-modal').hide();
    });
    $(".overlay").click(function(e) {
        if (!($(event.target).hasClass('product-modal') || $(e.target).parents(".product-modal").length)) {
          $('.product-modal .icon-close').click();
        }
    });
    $('.pagepopup .icon-close').click(function(){
        $('.pagepopup-container').removeClass('modal-show');
    });
    $('.pagepopup .no-thanks').click(function(){
        $('.pagepopup-container').removeClass('modal-show');
    });
    $(".stars-container").each(function(index, element){
        var str = $(".stars-container").closest(".rating-container").find(".rating-score").html();
        str = str.replace(/\s+/, "") ;
        var num = parseFloat(str);
        rateStyleJQ(num, element);
    });
    if(!$(".profile").length){
        $(".toProfile").hide();
    }
    if(!$(".blk__2columns").length){
        $(".toNotes").hide();
    }
    if(!$(".recipe").length){
        $(".toParing").hide();
    }
    $(".toSpec").click(function() {
        $("html,body").animate(
          {
            scrollTop: $(".wine-spec-container").offset().top
          },
          800 //speed
        );
    });
    $(".toProfile").click(function() {
        $("html,body").animate(
          {
            scrollTop: $(".profile").offset().top
          },
          800 //speed
        );
    });
    $(".toNotes").click(function() {
        $("html,body").animate(
          {
            scrollTop: $(".blk__2columns").offset().top
          },
          800 //speed
        );
    });
    $(".toParing").click(function() {
        $("html,body").animate(
          {
            scrollTop: $(".recipe").offset().top
          },
          800 //speed
        );
    });

    $(document).on('scroll', function() {
        if($('.product-anchor-nav').length){
            if($(this).scrollTop()>=$('.product-anchor-nav').position().top){
                if(!$('#menu-btn').is(":checked")){
                    $('.sticky-product-container').addClass("sticky-scroll");
                }
            }
            else{
                $('.sticky-product-container').removeClass("sticky-scroll");
            }
        }
    });
    var checkLoginWidget = setInterval(function(){ 
        if(!$('#c7-login').is(':empty')){
            afterLoginWidgetLoaded();
            clearInterval(checkLoginWidget);
        }
    }, 300);
    function afterLoginWidgetLoaded(){
        if($('.c7-login__logged-in').length!=0){
            $('.my-account-name').html($('.c7-login__logged-in').html());
            $('.my-account').show();
            $('.btn-logout').show();
            $('.my-account-name').show();
            $('.my-order').show();
            $('.sign-in').hide();
            $('.sign-up').hide();
            $('.login-widgets').addClass('loggedIn');
        }
        else {
            $('.my-account').hide();
            $('.btn-logout').hide();
            $('.my-account-name').hide();
            $('.my-order').hide();
            $('.sign-in').show();
            $('.sign-up').show();
            $('.login-widgets').removeClass('loggedIn');
        }
    }
    if($('.product-detail').length > 0){
        var addtoCartWidget = setInterval(function(){ 
            if(!$('.c7-buy-variant').is(':empty')){
                afteraddtoCartWidgetLoaded();
                clearInterval(addtoCartWidget);
            }
        }, 300);
    }
    function afteraddtoCartWidgetLoaded(){
        $('.c7-product__variant__price').append('<p style="order:3;">Bottle (750ml)</p>');
    }
    var checkRemoteForm = setInterval(function(){ 
        if(!$('.c7-form-wrapper').is(':empty')){
            afterRemoteFormLoaded();
            clearInterval(checkRemoteForm);
        }
    }, 300);
    function afterRemoteFormLoaded() {
        $('.c7-form label').each(function(){
            if ($(this).has('select').length) {
                return;
            } 
            $(this).find('input').attr("placeholder",$(this).text());
            
        });
    }
    var checkViewCart = setInterval(function(){ 
        if($('.c7-cart__buttons a:last-child').attr('href') == '/checkout' && $('.c7-cart__buttons a:last-child').html() !='Checkout'){
            $('.c7-cart__buttons a:last-child').html('Checkout');
        }
        if($('.c7-account-tile .c7-button-small').attr('href') =='/club'){
            $('.c7-account-tile .c7-button-small').attr('href', '/clubs');
        }
        if($('.c7-cart__cart-carrot_product_title .c7-button-small').html()!='Add'){
            $('.c7-cart .c7-cart__close').html('<span class="icon-close"></span>');
            $('.c7-cart__cart-carrot_product_subtitle').html($('.c7-cart__cart-carrot_product .c7-cart-items__price').html());
            $('.c7-cart__cart-carrot_product_title .c7-button-small').html('Add');
        }
    }, 300);
    function ajax_filter_category(){
        type_ids = [];
        varietal_ids = [];
        vintage_ids = [];
        filtering_price = [];
        wine_ids = [];
        $('#category-post-content .wine-card').each(function() {
            wine_ids.push($(this).data('id'));
        });
        if($('.filtering-price').length){
            filtering_price.push($('.filtering-price').data('low'));
            filtering_price.push($('.filtering-price').data('upper'));
        }
        if($('.filtering-category').length){
            $('.clear-filter').css("display","flex");
        }
        else{
            $('.clear-filter').css("display","none");
        }
        $('.filtering-varietal').each(function() {
            varietal_ids.push({"key":$(this).data('key'),"title":$(this).data('id')});
        });
        $('.filtering-type').each(function() {
            type_ids.push($(this).data('id'));
        });
        $('.filtering-vintage').each(function() {
            vintage_ids.push($(this).data('id'));
        });
        jQuery.ajax({
            type: 'POST',
            url: my_ajax_object.ajax_url,
            data: {"action": "load-filter2", 
                    type_ids : type_ids,
                    varietal_ids:varietal_ids, 
                    vintage_ids:vintage_ids,
                    price_range:filtering_price,
                    wine_ids:wine_ids,
                  },
            success: function(response) {
                if(response == "show_all"){
                    $('.shop-banner').show();
                    $('.shop-banner-mobile').show();
                    $('.wine-card').show();
                    $('.no-result').hide();
                    return false;
                }
                else{
                    $('.shop-banner').hide();
                    $('.shop-banner-mobile').hide();
                    var filtered_wines = JSON.parse(response);
                    console.log(filtered_wines,filtered_wines.length);
                    if(filtered_wines.length!=0){
                        $('.wine-card').each(function(){
                            if(filtered_wines.includes($(this).data('id'))){
                                $(this).show();
                            }
                            else {
                                $(this).hide();
                            }
                        });
                        $('.no-result').hide();
                    }
                    else {
                        $('.wine-card').hide();
                        $('.no-result').show();
                    }
                    return false;
                }
            }
        });
    
    }
    function rateStyleJQ(num, divID) {
        var ratingRounded = Math.floor(num);
        $(divID).find('.star-over').slice(0, ratingRounded).addClass('star-visible');
          var partialShade = Math.round((num-ratingRounded)*100);
          if (partialShade!= 0) {
              $($(divID).find('.star-over').get(ratingRounded)).addClass('star-visible').css("width", partialShade+"%");
        }
    }
    
    // $(window).load(function() {
    //     /************************
    //      * owl carousel - start
    //      ************************/
    //     // if (window.innerWidth < 1024) {
    //     //     $(".block-cards.owl-carousel").owlCarousel({
    //     //         dots: false,
    //     //         loop: true,
    //     //         stagePadding: 50,
    //     //         margin: 10,
    //     //         center: true,
    //     //         lazyLoad: true,
    //     //         responsive: {
    //     //             0: {
    //     //                 items: 1,
    //     //                 nav: false,
    //     //                 dots: true
    //     //             },
    //     //             640: {
    //     //                 items: 2,
    //     //                 nav: true,
    //     //                 dots: true,
    //     //                 navText: ['<span class="icon icon-arrow-left"></span>', '<span class="icon icon-arrow-right"></span>'],
    //     //             },
    //     //             1024: {
    //     //                 items: 3,
    //     //                 nav: false,
    //     //                 loop: false
    //     //             }
    //     //         }
    //     //     });
    //     // }
    //     /************************
    //      * owl carousel - end
    //      ************************/    
    // });        
    
    
});
